export const CATEGORIES = ['mirim', 'infantil', 'juvenil', 'adulto', 'master'];

export const AGE_RANGES = {
  mirim: { min: 0, max: 9 },
  infantil: { min: 10, max: 12 },
  juvenil: { min: 13, max: 15 },
  adulto: { min: 16, max: 34 },
  master: { min: 35, max: 200 },
};

export function calculateAge(birthDate, referenceDate = new Date()) {
  if (!birthDate) return null;
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return null;
  let age = referenceDate.getFullYear() - birth.getFullYear();
  const m = referenceDate.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && referenceDate.getDate() < birth.getDate())) age--;
  return age;
}

export function computeDefaultCategory(birthDate) {
  const age = calculateAge(birthDate);
  if (age === null) return null;
  for (const cat of CATEGORIES) {
    const { min, max } = AGE_RANGES[cat];
    if (age >= min && age <= max) return cat;
  }
  return null;
}

export function getEligibleCategories(birthDate) {
  const age = calculateAge(birthDate);
  if (age === null) return [];
  if (age >= AGE_RANGES.master.min) return ['adulto', 'master'];
  const def = computeDefaultCategory(birthDate);
  return def ? [def] : [];
}

export const CATEGORY_LABELS = {
  mirim: 'Mirim (7 a 9 anos)',
  infantil: 'Infantil (10-12 anos)',
  juvenil: 'Juvenil (13-15 anos)',
  adulto: 'Adulto (16+ anos)',
  master: 'Master (35+ anos)',
};
